import React from "react";
import CSS from "react-css-modules";
import classnames from "classnames";
import Fade from "react-reveal/Fade";
import CountUp from "react-countup";
import { Helmet } from "react-helmet-async";
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

import Header from "app/components/common/Header";
import Footer from "app/components/common/Footer";

import backgroundMain from "assets/images/background_main11.png";
import backgroundCount from "assets/images/background_count.png";
import chatieLogo from "assets/images/chatie_logo_n.png";
import appleIconWhite from "assets/images/ic_apple_w.png";
import playStoreIcon from "assets/images/ic_playstore.png";
import phone from "assets/images/phone.png";
import studio from "assets/images/studio.gif";

import styles from "./style.scss";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDescription: false,
      isHeaderDark: false,
      isStudio: false,
      isCount: false,
      isMapLoaded: false,
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.map = compose(
      withProps({
        googleMapURL:
          "https://maps.googleapis.com/maps/api/js?key=AIzaSyCxskPx24k6_p2zsoUz1QSP0pFo-oZFMAE&v=3.exp&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `320px` }} />,
        mapElement: <div style={{ height: `100%` }} />,
      }),
      withScriptjs,
      withGoogleMap
    )((props) => (
      <GoogleMap
        defaultZoom={16}
        defaultCenter={{ lat: 37.51248599957204, lng: 127.0532547618746 }}
      >
        <Marker position={{ lat: 37.51248599957204, lng: 127.0532547618746 }} />
      </GoogleMap>
    ));
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll, false);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    const { top: descriptionTop } = this.descriptionRef.getBoundingClientRect();
    const { top: studioTop } = this.studioRef.getBoundingClientRect();
    const { top: countTop } = this.countRef.getBoundingClientRect();
    const { innerHeight } = window;

    if (descriptionTop < innerHeight - 100) {
      this.setState({ isDescription: true });
    }
    if (descriptionTop < 250) {
      this.setState({ isHeaderDark: true });
    }

    if (descriptionTop > 400) {
      this.setState({ isHeaderDark: false });
    }

    if (studioTop < 300) {
      this.setState({ isStudio: true });
    }

    if (countTop < 500) {
      this.setState({ isCount: true });
    }
  }

  render() {
    const { isDescription, isHeaderDark, isStudio, isCount } = this.state;
    return (
      <React.Fragment>
        <Helmet>
          <link rel="canonical" href={window.location.href} />
        </Helmet>
        <Header themeDark={isHeaderDark} />
        <div styleName="chatie">
          <div
            styleName="chatie__main"
            style={{
              backgroundImage: `url(${backgroundMain})`,
            }}
          >
            <Fade>
              <div styleName="chatie__main__contents">
                <h4>이야기 풍선, 채티</h4>
                <h5>톡! 하면 팡! 터지는 재미</h5>
                <a href="https://share.chatie.me/ise9jh">
                  <button styleName="chatie__main__contents__app-download">
                    <img src={appleIconWhite} alt="앱스토어" />
                    <span>App Store</span>
                  </button>
                </a>
                <a href="https://share.chatie.me/neytbk">
                  <button styleName="chatie__main__contents__app-download">
                    <img src={playStoreIcon} alt="플레이스토어" />
                    <span>Google Play</span>
                  </button>
                </a>
              </div>
            </Fade>
          </div>
          <div
            styleName="chatie__description"
            ref={(node) => {
              this.descriptionRef = node;
            }}
          >
            <div styleName="chatie__description__contents">
              <Fade when={isDescription} duration={600}>
                <div styleName="chat--sender">
                  <div
                    styleName={classnames(
                      "chat__content",
                      "chat__content--profile"
                    )}
                  >
                    <p styleName="chat__content__name">채티</p>
                    <div styleName={classnames("text", "text--sender")}>
                      <div styleName="text--sender__end" />
                      <span>채티에 온 걸 환영해!</span>
                    </div>
                  </div>
                </div>
              </Fade>
              <Fade when={isDescription} duration={600}>
                <div
                  styleName={classnames(
                    "chat__content",
                    "chat__content--profile"
                  )}
                >
                  <p styleName="chat__content__name">채티즈</p>
                  <div styleName={classnames("text", "text--receiver")}>
                    <div styleName="text--receiver__end" />
                    <span>채티?</span>
                  </div>
                </div>
              </Fade>
              <Fade when={isDescription} duration={600} delay={200}>
                <div
                  styleName={classnames(
                    "chat__content",
                    "chat__content--profile"
                  )}
                >
                  <div styleName={classnames("text", "text--receiver")}>
                    <span>채티에 대해 알고 싶어!</span>
                  </div>
                </div>
              </Fade>
              <Fade when={isDescription} duration={600} delay={400}>
                <div styleName="chat--sender">
                  <div
                    styleName={classnames(
                      "chat__content",
                      "chat__content--profile"
                    )}
                  >
                    <p styleName="chat__content__name">채티</p>
                    <div styleName={classnames("text", "text--sender")}>
                      <div styleName="text--sender__end" />
                      <span>
                        이야기를 좋아하는 사람들을 위해 만들어진 앱이야
                      </span>
                    </div>
                  </div>
                </div>
              </Fade>
              <Fade when={isDescription} duration={600} delay={600}>
                <div
                  styleName={classnames(
                    "chat__content",
                    "chat__content--profile"
                  )}
                >
                  <p styleName="chat__content__name">채티즈</p>
                  <div styleName={classnames("text", "text--receiver")}>
                    <div styleName="text--receiver__end" />
                    <span>그럼 소설 서비스네</span>
                  </div>
                </div>
              </Fade>
              <Fade when={isDescription} duration={600} delay={800}>
                <div
                  styleName={classnames(
                    "chat__content",
                    "chat__content--profile"
                  )}
                >
                  <div styleName={classnames("text", "text--receiver")}>
                    <span>다른 서비스와 다른점이 있어?</span>
                  </div>
                </div>
              </Fade>
              <Fade when={isDescription} duration={600} delay={1000}>
                <div styleName="chat--sender">
                  <div
                    styleName={classnames(
                      "chat__content",
                      "chat__content--profile"
                    )}
                  >
                    <p styleName="chat__content__name">채티</p>
                    <div styleName={classnames("text", "text--sender")}>
                      <div styleName="text--sender__end" />
                      <span>
                        지금 같은 채팅 형식으로 누구나 쉽게 볼 수 있어!
                      </span>
                    </div>
                  </div>
                </div>
              </Fade>
              <Fade when={isDescription} duration={800} delay={1100}>
                <h4>
                  누구에게나 익숙한
                  <br />
                  <span>채팅형 콘텐츠</span>서비스!
                  <br />
                </h4>
              </Fade>
            </div>
          </div>
          <div
            styleName="chatie__count"
            ref={(node) => {
              this.countRef = node;
            }}
            style={{ backgroundImage: `url(${backgroundCount})` }}
          >
            <Fade when={isCount}>
              <img src={chatieLogo} alt="chatie" />
            </Fade>
            <div styleName="chatie__count__wrap">
              <p>
                누적 유저 수
                {isCount && (
                  <React.Fragment>
                    <CountUp end={430} />만
                  </React.Fragment>
                )}
              </p>
              <p>
                활성 작품 수
                {isCount && (
                  <React.Fragment>
                    <CountUp end={60} />만
                  </React.Fragment>
                )}
              </p>
              {/* <p>전체 탭 수{isCount && <React.Fragment><CountUp end={148} />억</React.Fragment>}</p> */}
            </div>
          </div>
          <div
            styleName="chatie__studio"
            ref={(node) => {
              this.studioRef = node;
            }}
          >
            <Fade top when={isStudio}>
              <div styleName="chatie__studio__example">
                <img src={studio} alt="에디터" />
                <img
                  styleName="chatie__studio__example__frame"
                  src={phone}
                  alt="핸드폰"
                />
              </div>
            </Fade>
            <Fade when={isStudio}>
              <div>
                <h4>당신의 이야기도 보여주세요</h4>
                <p>
                  채티에 있는 스튜디오를 통해 누구나 쉽게 이야기를 만들 수
                  있습니다!
                </p>
              </div>
            </Fade>
          </div>
          <div styleName="section-contact">
            <div styleName="section-contact__map">
              <this.map />
            </div>
          </div>
          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

const Component = CSS(Home, styles, { allowMultiple: true });

export default Component;



// WEBPACK FOOTER //
// ./src/app/pages/Home/index.js